// extracted by mini-css-extract-plugin
export default {"gpsBlocked":"_1NcPn","modal":"_13biE","close":"_1D1x-","container":"scyLP","title":"-wXi5","description":"Ecdc_"};